var percyInteractiveLPComp = (function() {
  return {
    init: init
  };

  //init function
  function init() {
    document.addEventListener('DOMContentLoaded', function() {
      var toggleCta = document.getElementById("percyInteractiveOverlayToggle"),
      overlayWrap = document.getElementById("percy-in-com-body-content-wrap-img");

      if (toggleCta && overlayWrap) {
        toggleCta.addEventListener("click", function () {
          overlayWrap.classList.toggle("percy-in-com-body-content-wrap-img-overlay-black");

          //lazy load image
          lazyLoading.show();
        });
      }

      //device button
      var deviceCTAs = document.querySelectorAll("button.percy-in-com-body-head-right-icon"),
      ctaWarp = document.querySelectorAll(".percy-in-com-body-content-up-wrap"),
      ctaImgTag = document.querySelectorAll(".percy-in-com-body-content-wrap-img-tag"),
      deviceDivider = document.querySelector(".percy-in-com-body-content-divider");

      for (var i = 0; i < deviceCTAs.length; i++) {
        deviceCTAs[i].addEventListener("click", function () {
          var that = this,
          device = that.dataset.device;

          //cta
          for (var j = 0; j < deviceCTAs.length; j++) {
            var cta = deviceCTAs[j];
            if (cta.dataset.device == device) {
              cta.classList.add("active");
            } else {
              cta.classList.remove("active");
            }
          }

          //image
          for (var j = 0; j < ctaImgTag.length; j++) {
            var cta = ctaImgTag[j];
            if (cta.dataset.device == device) {
              cta.classList.remove("hide");
            } else {
              cta.classList.add("hide");
            }
          }
          
          if (device == "mobile") {
            for (var index = 0; index < ctaWarp.length; index++) {
              var elem = ctaWarp[index];
              elem.classList.add("mobile");
            }

            deviceDivider.classList.add("mobile");
          } else {
            for (var index = 0; index < ctaWarp.length; index++) {
              var elem = ctaWarp[index];
              elem.classList.remove("mobile");
            }
            deviceDivider.classList.remove("mobile");
          }

          //lazy load image
          lazyLoading.show();
        });
      }
    });
  }
})();

percyInteractiveLPComp.init();